import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import { TextField } from 'components/inputs';

export const RadioGroupStyled = styled(RadioGroup)(() => ({
  width: '100%'
}));

export const MultilineTextField = styled(TextField)(() => ({
  marginTop: '5px'
}));

export const Content = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  margin: theme.spacing(2),
  maxWidth: `calc(100% - ${theme.spacing(4)})`,
  width: theme.spacing(50)
}));

export const Description = styled('p')(({ theme }) => ({
  margin: theme.spacing(2, 0, 0),
  width: '100%',
  paddingTop: '5px'
}));

//RTEXT-618
export const EditorContainer = styled('div')(({ theme }) => ({
  border: '1px solid #ddd',
  width: '100%',
  marginTop: '10px',
  borderRadius: theme.borderRadius.base
}));

export const Title = styled('h3')(({ theme }) => ({
  color: theme.color.primary.main,
  fontSize: theme.fontSize.large,
  margin: theme.spacing(0, 0, 2, 0),
  textTransform: 'uppercase'
}));

export const DateLabel = styled('div')(({ theme }) => ({
  color: theme.color.primary.main,
  fontSize: theme.fontSize.normal,
  margin: theme.spacing(0, 0, 1, 0)
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  margin: theme.spacing(1),
  width: '100%'
}));

export const TimeTrackingOptionsContainer = styled('div')(({ theme, shrinkSpace }) => ({
  alignItems: 'left',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'left',
  paddingTop: shrinkSpace ? '0px' : '10px',
  margin: shrinkSpace ? '-5px' : theme.spacing(1),
  width: '100%'
}));

export const TimeTrackingOption = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  flex: '1 0 50%',
  justifyContent: 'left',
  position: 'relative'
}));

export const Border = styled('div')(({ theme, mt }) => ({
  width: '100%',
  marginTop: mt ? `${mt}px` : '0px',
  borderBottom: `1px solid ${theme.color.grey[500]}`
}));
